import { fetchServerParams } from '../../../../api/server.api.js';
import Validatable from '../../../mixins/Validatable.js';
import ContentLoader from '../../../mixins/ContentLoader.js';
import ServerForm from '../../../components/server/ServerForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
	components: {
		ServerForm,
		ValidationObserver
	},
	mixins: [Validatable, ContentLoader],
	data() {
		return {
			server: {
				domain: null,
				pageStyle: null,
				timeZone: null,
				streamEnabled: false,
				automaticResults: false,
				displayResults: false,
				twitchChannelName: null,
				instanceId: null,
				siblingServerIds: [],
				ueVersion: null,
				hoursBeforeFirstSortitionToTurnOnStream: null,
				hoursAfterLastSortitionToTurnOffStream: null,
				resultApiUserAttributes: {
					username: null,
					password: null,
					domain: null
				}
			},
			params: {
				pageStyles: [],
				servers: [],
				ueVersions: []
			}
		};
	},
	methods: {
		async fetchParams() {
			try {
				const response = await fetchServerParams();

				this.params = response.data;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
